<template>
  <b-modal size="lg" id="modalListaSede" title="Lista Sedi" hide-header-close ref="modalListaSede">
      <div>
          <b-alert show variant="warning" style="padding: 4px;">
              <p style="font-size: small">
                  {{infoHeaderLista}}
              </p>
          </b-alert>
      </div>
    <div class="d-block text-center">
      <h3 class="title-modal-lista-sedi">Seleziona la sede</h3>
    </div>
    <b-table
      :items="jsonData.listaSedi"
      :fields="fields"
      striped
      responsive
      hover
      :current-page="currentPage"
      :per-page="perPage"
      stacked="lg"
      selectable
      select-mode="single"
      @row-selected="onRowSelected"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #cell(data)="row">
        <span>{{row.item.dataAppuntamento}} {{row.item.oraAppuntamento}}</span>
      </template>

      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <div class="divcheck">
            <span aria-hidden="true">&check;</span>
          </div>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
    </b-table>
    <template>
      <b-row>
        <b-col cols="6" v-if="rows >0">
          <strong> Sono presenti {{ rows }} strutture</strong>
        </b-col>
          <b-col cols="6" v-else>
              <strong> Non sono presenti altre disponibilità</strong>
          </b-col>
        <b-col cols="6">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </template>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
    <template #modal-footer="{}">
      <b-button class="btn-secondary" @click="onClose()">
        Chiudi
      </b-button>
      <b-button class="btn-primary" @click="onConfermaSede()" :disabled="disabilitaOk">
        OK
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Loading from "vue-loading-overlay";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  components: { Loading },
  props: {
    presaInCarico: Object,
    listaSedi: Array
  },
  data() {
    return {
        infoHeaderLista: "La lista fornisce un elenco di tutte le sedi, sia all'interno che al di fuori del distretto, che offrono le prestazioni richieste." +
            " La data indicata rappresenta, al momento, la prima disponibilità",
      pathResourceListaSedi: "/api/v2.0/appecupt/aslengi/prentemp/sedi",
      pathResourcePrimaDisponibilitaSede: "/api/v2.0/appecupt/aslengi/ricercaDisponibilita",
      jsonData: {
        listaSedi: {},
      },
      ricercaDisponibilitaSedi: {
        sendData: [],
      },
      tokenLogin: null,
      isLoading: false,
      sedeSelezionata: {},
      fields: [
        {
          label: "Codice Sede",
          key: "idSede",
        },
        {
          label: "Nome Sede",
          key: "descSede",
          sortable: true,
        },
        {
          label: "Prima Data Presunta",
          key: "data",
          sortable: false,
        },
        {
          label: "Selezionato",
          key: "selected",
          thStyle: "width: 6rem",
        },
      ],
      perPage: 11,
      currentPage: 1,
      disabilitaOk: true,
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = me.tokenLogin = sessionStorage.getItem("loginData");
    if(!me.listaSedi || me.listaSedi.length === 0) {
      me.loadData();
    } else
      me.jsonData.listaSedi = me.listaSedi;

      let msg = getVocabolario("infoHeaderListaStrutture")
      if(msg)
          this.infoHeaderLista = msg;
  },
  computed: {
    rows() {
      return this.jsonData.listaSedi.length;
    },
  },
  methods: {
    async loadData() {
      let me = this;
      me.$emit("setLoading", true);
      try {
        me.presaInCarico.prestazioni.forEach((item) => {
          me.ricercaDisponibilitaSedi.sendData.push({
            idPrestazioneAnagrafica: item.idPrestazioneAnagrafica,
            idPrestazione: item.idPrestazione,
            reparto: item.reparto,
          });
        });
        const responseListaSedi = await EngiService.listaSedi(me.ricercaDisponibilitaSedi.sendData);
        if (responseListaSedi.data.stato === 200) {
          me.$emit("setLoading", false);
          me.jsonData.listaSedi = responseListaSedi.data.data;
          console.log(me.jsonData.listaSedi)
          me.$emit("setListaSedi", me.jsonData.listaSedi);
          me.$emit("setMountedAfterLista")
        } else {
          me.$emit("setLoading", false);
          this.$bvModal
            .msgBoxOk(responseListaSedi.data.errore, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.$emit("setLoading", false);
              me.onAnnulla();
            })
            .catch((err) => {
              me.$emit("setLoading", false);
              me.onAnnulla();
              console.log(err);
            });
        }
      } catch (e) {
        me.$emit("setLoading", false);
        me.onAnnulla();
        console.log(e);
      }
    },
    onRowSelected(item) {
      let me = this;
      me.sedeSelezionata = item;
      me.$emit("onSedeSelezionata", me.sedeSelezionata);
    },
    onClose() {
      this.$emit("chiudi");
    },
    async onConfermaSede() {
      let me = this;
      const bodyPrimaDispSede = [];
      me.presaInCarico.prestazioni.forEach((item) => {
        bodyPrimaDispSede.push({
          idPrestazioneAnagrafica: item.idPrestazioneAnagrafica,
          idPrestazione: item.idPrestazione,
          reparto: item.reparto,
        });
      });
      try {
        me.$emit("setLoading", true);
        const responseConfermaSede = await EngiService.ricercaPrimaDisponibilitaNre(bodyPrimaDispSede, me.sedeSelezionata[0].idSede);
        if (responseConfermaSede.data.stato === 200) {
          me.$emit("onRifiutaPrimaDisponibilita", responseConfermaSede.data.data);
          me.$emit("onSedeSelezionata", me.sedeSelezionata[0].idSede);
          me.$emit("setLoading", false);
        } else {
          me.$emit("setLoading", false);
          this.$bvModal
            .msgBoxOk(responseConfermaSede.data.errore, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.$emit("setLoading", false);
            })
            .catch((err) => {
              me.$emit("setLoading", false);
              console.log(err);
            });
        }
      } catch (error) {
        console.log(error);
        me.$emit("setLoading", false);
      }
    },
    async onAnnulla() {
      let me = this;
      me.isLoading = true;
      try {
          await EngiService.annullaPrenotazioneSospesa()
                    .then(() => {
                      me.isLoading = false;
                      window.location.reload();
                    })
                    .catch((error) => {
                      me.isLoading = false;
                      console.log(error);
                      this.$bvModal
                          .msgBoxOk(error.response, {
                            title: "Errore",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "vv-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                            noCloseOnBackdrop: true,
                            noCloseOnEsc: true,
                          })
                          .then(() => {
                            window.location.reload();
                          })
                          .catch(() => {
                            window.location.reload();
                          });
                    });
              } catch (e) {
                me.isLoading = false;
                me.$bvModal
                    .msgBoxOk(e, {
                      title: "Errore",
                      size: "md",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      noCloseOnBackdrop: true,
                      noCloseOnEsc: true,
                    })
                    .then(() => {
                      window.location.reload();
                    })
                    .catch(() => {
                      window.location.reload();
                    });
              }
    },
  },
  watch: {
    sedeSelezionata: function (data) {
      let me = this;
      console.log(data);
      if (data.length > 0) {
        me.disabilitaOk = false;
      } else {
        me.disabilitaOk = true;
      }
    },
  },
};
</script>
